export default {

  currentQuarter (state) {
    return state.quarters.find(q => q.is_current) || state.quarters[state.quarters.length - 1]
  },

  allowedClassifications: (state) => (allowedArray) => {
    return state.classifications
      .filter(obj => allowedArray.includes(obj.id))
      .map(obj => ({
        id: obj.id,
        description: obj.name,
        count: 0,
        full_description: `Fund Classification: ${obj.name}`,
        filter_identifier: 'fund_classification'
      }))
  }

}
